class Calc {
    constructor() {
        /* Get fields */
        this.wire_type = document.getElementById('wire_type');
        this.wire_color = document.querySelectorAll('#wire_color input[type=radio][name="wire-color"]');
        this.wire_length = document.getElementById('wire_length');
        this.top_connection = document.getElementById('top_connection');
        this.bottom_connection = document.getElementById('bottom_connection');
        this.wire_cover_top = document.getElementById('wire_cover_1');
        this.wire_cover_bottom = document.getElementById('wire_cover_2');
        this.aux_wire_type = document.getElementById('aux_wire_type');
        this.aux_wire_length = document.getElementById('aux_wire_length');
        this.aux_lug = document.getElementById('aux_lug');
        this.heat_shield = document.getElementById('heat_shield');
        this.loom = document.getElementById('loom');
        this.details = document.getElementById('custom-cable__details');
        this.reset = document.getElementById('reset-form-link');
        this.btn = document.getElementById('custom_add_to_cart');
        
        this.labor_cut = document.getElementById('labor_cut').value;
        this.aux_cost = document.getElementById('aux_cost').value;
        
        this.desc = document.getElementById('cable_desc');
        this.form = document.getElementById('custom-cable__form');
        this.cost = document.getElementById('estimated_cost');
        
        /* Events that fire on change */
        this.events();

    }


    events() {

        this.wire_length.onchange = () => {
            this.calculate();
        }

        this.wire_cover_top.onclick = (e) => {
            this.calculate();
        }

        this.wire_cover_bottom.onclick = (e) => {
            this.calculate();
        }

        this.aux_wire_length.onchange = () => {
            this.calculate();
        }

        this.details.onchange = (e) => {
            this.calculate();
        }

        this.heat_shield.onclick = (e) => {
            this.calculate();
        }

        this.loom.onclick = (e) => {
            this.calculate();
        }

        this.form.onsubmit = (e) => {
            e.preventDefault();
        }



    }

    calcDetails(selector, num) {

        let field = document.getElementById(selector+'_'+num);
        let name = field.dataset.name;
        let price = field.dataset.price;
        let desc = field.dataset.desc;
        let price_adj = field.dataset.price_adj;
        let details = [];
        return details = [name,price,desc,price_adj];

    }

    calcZero() {
        let details = [];
        return details = ["",0,"",0];
    }

    calculate() {

        /* Get wire type details */
        let wire_type_details;
        if(this.wire_type.value !== "-1") {
            wire_type_details = this.calcDetails('wire_type', this.wire_type.value);
        } else {
            wire_type_details = this.calcZero();
        }

        /* Get wire color details */
        let wire_color_details;
        if(this.wire_color[0].checked) {
            wire_color_details = this.calcDetails('wire_color_data', '1');
        } else {
            wire_color_details = this.calcDetails('wire_color_data', '2');
        }

        /* Get top connection details for main wire */
        let top_connection_details;
        if(this.top_connection.value !== "-1") {
            top_connection_details = this.calcDetails('wire_lugs', this.top_connection.value);
        } else {
            top_connection_details = this.calcZero();
        }

        /* Get bottom connection details for main wire */
        let bottom_connection_details;
        if(this.bottom_connection.value !== "-1") {
            bottom_connection_details = this.calcDetails('wire_lugs', this.bottom_connection.value);
        } else {
            bottom_connection_details = this.calcZero();
        }

        /* Get top cover */
        let top_cover_details;
        if(this.wire_cover_top.checked) {
            top_cover_details = this.calcDetails('wire_cover_data', this.wire_cover_top.value );
        } else {
            top_cover_details = this.calcZero();
        }    

        /* Get bottom cover */
        let bottom_cover_details;
        if(this.wire_cover_bottom.checked) {
            bottom_cover_details = this.calcDetails('wire_cover_data', this.wire_cover_bottom.value );
        } else {
            bottom_cover_details = this.calcZero();
        }   

        /* Get aux wire type details */
        let aux_wire_opt_details;
        if(this.aux_wire_type.value !== "-1") {
            aux_wire_opt_details = this.calcDetails('wire_aux_opt', this.aux_wire_type.value);
        } else {
            aux_wire_opt_details = this.calcZero();
        }

        /* Get aux wire lug details */
        let aux_lug_details;
        if(this.aux_lug.value !== "-1") {
            aux_lug_details = this.calcDetails('wire_aux_clamp', this.aux_lug.value);
        } else {
            aux_lug_details = this.calcZero();
        }

        /* Get heat shield */
        let heat_shield_details;
        if(this.heat_shield.checked) {
            heat_shield_details = this.calcDetails('wire_cover_extra', '1' );
 
        } else {
            heat_shield_details = this.calcZero();

        }   

        /* Get loom */
        let loom_details;
        if(this.loom.checked) {
            loom_details = this.calcDetails('loom_extra', '1' );
        } else {
            loom_details = this.calcZero();
        }   


        /* Calculation */

        if( this.wire_type.value != "-1" && this.wire_length.value != 0)
        {
        let result = ( parseFloat(this.wire_length.value) * parseFloat(wire_type_details[1]) /12 ) ;

        let top_connection_sum = parseFloat(top_connection_details[1]) * parseFloat(wire_type_details[3]);
        let bottom_connection_sum = parseFloat(bottom_connection_details[1]) * parseFloat(wire_type_details[3]);
        let top_cover_sum = parseFloat(top_cover_details[1]);
        let bottom_cover_sum = parseFloat(bottom_cover_details[1]);
     
        result = result + parseFloat(top_connection_sum) + parseFloat(bottom_connection_sum) + parseFloat(top_cover_sum) + parseFloat(bottom_cover_sum) + parseFloat(this.labor_cut) + parseFloat(heat_shield_details[1]) + parseFloat(loom_details[1]);


        /* Create a description */
        let descval = this.wire_length.value +" in, ";
        descval = descval + wire_type_details[2] + " " + wire_color_details[2] + ", ";
        descval = descval + top_connection_details[2];	
        descval = descval + " " + top_cover_details[2];
        descval = descval + ", " + bottom_connection_details[2];
        descval = descval + " " + bottom_cover_details[2];
        descval = descval + " " + heat_shield_details[2];
        descval = descval + " " + loom_details[2];
        

        if(this.aux_wire_type.value != "-1") {

            result = result + parseFloat(this.aux_cost);
            let auxl = (parseFloat(this.aux_wire_length.value) * parseFloat(aux_wire_opt_details[1]) / 12);
            result = result + auxl;
            let auxclamp = parseFloat(aux_lug_details[1]) * parseFloat(aux_wire_opt_details[3]);
            result = result + auxclamp;
            
            /* Add a description for aux.. */
            descval = descval + " AUX: " + this.aux_wire_length.value + " in, " + aux_wire_opt_details[2];		
            descval = descval + " " + aux_lug_details[2];
            
        }

        descval = descval + " " + this.details.value;

        this.desc.innerHTML = descval;
        this.cost.innerHTML = parseFloat(result).toFixed(2);
        
        } else {
        this.cost.innerHTML = parseFloat(0.00).toFixed(2);
        this.desc.innerHTML = '';
        }
    }

}

export default Calc;